import React from "react";
import { Link } from "react-router-dom";
import { Navbar, Nav, Button, Image } from "react-bootstrap";

import Logo from "../../assets/img/kinexion-logo.png";

const PublicNavigation = () => {
  return (
    <Navbar fixed="top" className="top-menu" expand="lg" style={{ backgroundColor: '#fff', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
      <div className="container-fluid px-4">
        <Link to="/pricing" className="navbar-brand">
          <Image src={Logo} alt="Logo" style={{ height: '40px' }} />
        </Link>

        <Navbar.Toggle aria-controls="public-navbar-nav" />

        <Navbar.Collapse id="public-navbar-nav">
          <Nav className="ms-auto align-items-center">
            <Link to="/pricing" className="nav-link me-3">
              Precios
            </Link>
            <Link to="/privacy-policy" className="nav-link me-3">
              Privacidad
            </Link>
            <Link to="/terms-of-service" className="nav-link me-3">
              Terminos
            </Link>
            <Link to="/">
              <Button variant="primary" size="sm">
                Iniciar Sesión
              </Button>
            </Link>
          </Nav>
        </Navbar.Collapse>
      </div>
    </Navbar>
  );
};

export default PublicNavigation;
